export default __webpack_public_path__ + "static/media/call-closing.ab459ac2.svg";